import React, { useEffect, useState, useCallback } from 'react';
import { Copy, Check } from 'lucide-react';
import axios from 'axios';
import "./EkycLogs.css"



export default function EkycLogs2() {

    const [merchantId, setMerchantId] = useState("");
    const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
    const [allLogs, setAllLogs] = useState([]);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedLog, setSelectedLog] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [copied, setCopied] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);



    const totalPages = Math.ceil(logs.length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const paginatedLogs = logs.slice(startIndex, startIndex + rowsPerPage);

    const handleCopy = (data) => {

        const textToCopy = JSON.stringify(data, null, 2);
        navigator.clipboard.writeText(textToCopy);


        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
    };

    const formatToCustomDate = (dateStr) => {
        if (!dateStr || dateStr === "-") return "-";
        const [year, month, day] = dateStr.split('-');
        return `${month}-${day}-${year}`;
    };


    const fetchLogsByDate = useCallback(async (selectedDate) => {
        if (!selectedDate) return;
        setLoading(true);
        try {
            const res = await axios.post(
                `https://bumppy.in/fingpay/v1/aeps/fetch_sendotp_logs.php?date=${selectedDate}`
            );

            const rawData = res.data;

            if (typeof rawData === 'string') {
                const blocks = rawData.split(/\[\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}\]/).slice(1);
                const parsedLogs = [];

                for (let i = 0; i < blocks.length; i += 2) {
                    try {
                        const requestPart = blocks[i] || "";
                        const responsePart = blocks[i + 1] || "";

                        let reqJson = {};
                        const reqString = requestPart.replace(/REQUEST:\s*/, "").split(/<br\s*\/?>/i)[0].trim();
                        if (reqString && reqString !== "null") {
                            try { reqJson = JSON.parse(reqString); } catch (e) { reqJson = { raw: reqString }; }
                        }

                        const mId = reqJson.merchantLoginId || "";
                        if (!mId.startsWith("BR")) {
                            continue;
                        }

                        let resJson = {};
                        const resString = responsePart.replace(/RESPONSE:\s*/, "").split(/<br\s*\/?>/i)[0].trim();
                        if (resString && resString !== "null") {
                            try { resJson = JSON.parse(resString); } catch (e) { resJson = { raw: resString }; }
                        }

                        const d = resJson.data || {};
                        const r = reqJson || {};
                        const rawDateMatch = blocks[i].match(/\d{4}-\d{2}-\d{2}/);
                        const rawDate = rawDateMatch ? rawDateMatch[0] : selectedDate;

                        parsedLogs.push({
                            sr: parsedLogs.length + 1,
                            userId: r.merchantLoginId || "-",
                            pan: r.panNumber || d.panNumber || "-",
                            mobile: r.mobileNumber || d.mobileNumber || "-",
                            aadhar: r.aadharNumber || d.aadharNumber || "XXXXXXXXXXXX",
                            date: formatToCustomDate(rawDate),
                            status: resJson.status === true ? "Success" : "Failed",
                            message: resJson.message || "No Message",
                            name: d.name || "N/A",
                            rawData: resJson,
                            requestData: reqJson
                        });
                    } catch (e) {
                        console.error("Block parsing error:", e);
                    }
                }

                setLogs(parsedLogs);
                setAllLogs(parsedLogs);
            }
        } catch (err) {
            console.error("Fetch Error:", err);
        } finally {
            setLoading(false);
        }
    }, []);


    useEffect(() => {
        fetchLogsByDate(date);
    }, [date, fetchLogsByDate]);

    const handleSearch = (searchValue) => {
        setMerchantId(searchValue);

        if (!searchValue.trim()) {
            setLogs(allLogs);
            return;
        }

        const filtered = allLogs.filter(item =>
            item.userId.toLowerCase().includes(searchValue.toLowerCase()) ||
            item.aadhar.includes(searchValue) ||
            (item.name && item.name.toLowerCase().includes(searchValue.toLowerCase()))
        );
        setLogs(filtered);
    };
    return (
        <div className="ezlog-logs-container">
            <div className="ezlog-max-container">
                <div className="ezlog-main-unified-card">
                    <div className="ezlog-card-header-section">
                    <h2 className="ezlog-text-3xl font-bold heading">AEPS Logs</h2>
                    <div className="ezlog-flex-responsive gap-4">
                        <input
                            type="text"
                            className="ezlog-input-field"
                            placeholder="Search ID or Aadhar..."
                            value={merchantId}
                            onChange={(e) => handleSearch(e.target.value)}
                        />
                        <input
                            type="date"
                            className="ezlog-input-field"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                        />
                    </div>
                </div>

                <div className="ezlog-table-card">
                    <div className="ezlog-scroll-wrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>Sr</th>
                                    <th>Date</th>
                                    <th>User ID</th>
                                    <th>Mobile No.</th>
                                    <th>Pan No.</th>
                                    <th>Aadhar No.</th>
                                    <th className="text-right">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr><td colSpan="6" className="text-center py-20">Processing...</td></tr>
                                ) : paginatedLogs.length > 0 ? (
                                    paginatedLogs.map((row, index) => (
                                    <tr key={index}>
                                            <td className="ezlog-sr-col">{row.sr.toString().padStart(2, '0')}</td>
                                            <td className="ezlog-user-id-col">{row.date}</td>
                                            <td className="ezlog-user-id-col">{row.userId}</td>
                                            <td className="ezlog-user-id-col">{row.mobile}</td>
                                            <td className="ezlog-user-id-col">{row.pan}</td>
                                            <td><code className="ezlog-aadhar-code">{row.aadhar}</code></td>

                                        <td>
                                                <div className="ezlog-btn-group">

                                                    <button className="ezlog-btn-action" onClick={() => {
                                                    setSelectedLog({
                                                        ...row,
                                                        rawData: row.requestData,
                                                        modalTitle: "Full API Request"
                                                    });
                                                    setShowModal(true);
                                                }}>Request</button>
                                                    <button className="ezlog-btn-action" onClick={() => {
                                                    setSelectedLog({
                                                        ...row,
                                                        modalTitle: "Full API Response"
                                                    });
                                                    setShowModal(true);
                                                }}>Response</button>
                                            </div>
                                        </td>
                                    </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan="7" style={{ color: '#64748b', fontWeight: 'bold', textAlign:"center"}}>No logs found</td></tr>
                                )}
                           
                            </tbody>
                        </table>
                        <div className="ezlog-pagination">
                            <div className="ezlog-pagination-info">
                                Showing {startIndex + 1} to {Math.min(startIndex + rowsPerPage, logs.length)} of {logs.length} entries
                            </div>

                            <div className="ezlog-pagination-controls">
                                <button disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)}>Prev</button>
                                <span>Page {currentPage} of {totalPages || 1}</span>
                                <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(prev => prev + 1)}>Next</button>

                                <select value={rowsPerPage} onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}>
                                    {[10, 20, 50, 100].map(size => (
                                        <option key={size} value={size}>{size}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                </div>


            {showModal && selectedLog && (
                <div className="ezlog-modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="ezlog-modal-card" onClick={(e) => e.stopPropagation()}>
                        <div className="ezlog-modal-header">
                            <div>
                                <h3>{selectedLog.modalTitle || "Log Details"}</h3>
                                <p>Merchant ID: {selectedLog.userId}</p>
                            </div>
                            <button className="ezlog-copy-button" onClick={() => handleCopy(selectedLog)}>
                                {copied ? <Check size={18} /> : <Copy size={18} />}
                                {copied ? "Copied" : "Copy All"}
                            </button>
                        </div>



                        <div className="ezlog-modal-body">
                            <table className="ezlog-modal-table">
                                <tbody>
                                    {Object.entries(selectedLog.requestData || {}).map(([key, value]) => (
                                        <tr key={`req-${key}`}>
                                            <td className="ezlog-label">{key.replace(/([A-Z])/g, ' $1')}</td>
                                            <td className="ezlog-value">{value?.toString() || "null"}</td>
                                        </tr>
                                    ))}

                               
                                    {selectedLog.rawData && Object.keys(selectedLog.rawData).length > 0 ? (
                                        Object.entries(selectedLog.rawData).map(([key, value]) => (
                                        <tr key={`res-${key}`}>
                                            <td className="ezlog-label">{key.replace(/([A-Z])/g, ' $1')}</td>
                                            <td className="ezlog-value">
                                                    {value !== null && value !== undefined
                                                        ? (typeof value === 'object' ? (
                                                        <pre style={{ fontSize: '10px' }}>
                                                            {JSON.stringify(value, null, 2)}
                                                        </pre>
                                                        ) : (
                                                            value.toString()
                                                        )
                                                        ) : (
                                                            <span style={{ color: '#475569' }}>null</span>
                                                        )}
                                            </td>
                                        </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="2" className="ezlog-empty-state">
                                                <div className="ezlog-empty-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                                                </div>
                                                <p style={{ color: '#64748b', fontWeight: 'bold' }}>No details available</p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="ezlog-modal-footer">
                            <button className="ezlog-close-btn" onClick={() => setShowModal(false)}>
                                Close Details
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
